// Демо-режим: полностью локальные мок-данные в памяти. Ни один запрос не
// уходит на сервер, ничего не сохраняется — при выходе/перезагрузке данные
// сбрасываются. Флаг режима хранится в localStorage['trandi_demo'].
const DEMO_KEY = 'trandi_demo';

export function isDemoMode() {
  try {
    return localStorage.getItem(DEMO_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function enterDemoMode() {
  try {
    localStorage.setItem(DEMO_KEY, '1');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  } catch (e) {}
  resetDemoState();
}

export function exitDemoMode() {
  try {
    localStorage.removeItem(DEMO_KEY);
  } catch (e) {}
  resetDemoState();
}

export const DEMO_USER = {
  id: 'user-demo-me',
  username: 'demo',
  email: 'demo@trandi.app',
  displayName: 'Гость Trandi',
  avatarUrl: null,
  statusText: 'Демо-режим',
  emailConfirmed: true,
  theme: 'light',
  isAdmin: false,
  mustChangePassword: false,
};

const DEMO_USERS = [
  DEMO_USER,
  { id: 'user-demo-anya', username: 'anya', displayName: 'Аня Смирнова', email: 'anya@demo.trandi', avatarUrl: null, statusText: 'в сети' },
  { id: 'user-demo-boris', username: 'boris', displayName: 'Борис Волков', email: 'boris@demo.trandi', avatarUrl: null, statusText: 'был(а) недавно' },
  { id: 'user-demo-masha', username: 'masha', displayName: 'Маша Орлова', email: 'masha@demo.trandi', avatarUrl: null, statusText: 'в сети' },
];

const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#667eea"/><stop offset="1" stop-color="#764ba2"/></linearGradient></defs><rect width="1024" height="1024" fill="url(#g)"/><circle cx="512" cy="400" r="170" fill="#ffffff" opacity="0.18"/><text x="512" y="430" font-size="76" text-anchor="middle" fill="#ffffff" font-family="sans-serif">AI</text><text x="512" y="640" font-size="44" text-anchor="middle" fill="#ffffff" font-family="sans-serif">Демо-генерация</text><text x="512" y="720" font-size="30" text-anchor="middle" fill="#ffffff" opacity="0.8" font-family="sans-serif">Trandi demo</text></svg>';
const DEMO_AI_IMAGE = `data:image/svg+xml;base64,${typeof btoa !== 'undefined' ? btoa(unescape(encodeURIComponent(svg))) : ''}`;

let seq = 100;
const uid = (p) => `${p}-demo-${++seq}`;

let demo = null;

function mkMsg(chatId, sender, content, minutesAgo) {
  return {
    id: uid('msg'),
    chatId,
    senderId: sender.id,
    senderDisplayName: sender.displayName,
    senderUsername: sender.username,
    senderAvatarUrl: sender.avatarUrl || null,
    content,
    type: 'TEXT',
    createdAt: new Date(Date.now() - minutesAgo * 60000).toISOString(),
    reactions: [],
    attachments: [],
    isDeleted: false,
    isPinned: false,
    editedAt: null,
  };
}

function buildDemoState() {
  const me = DEMO_USER;
  const anya = DEMO_USERS[1];
  const boris = DEMO_USERS[2];
  const masha = DEMO_USERS[3];

  const selfChat = {
    id: 'chat-demo-self', name: 'Своё', isGroup: false, isChannel: false,
    participants: [{ userId: me.id, displayName: me.displayName, avatarUrl: null }],
    avatarUrl: null, lastMessage: null, unreadCount: 0, muted: false,
  };
  const anyaChat = {
    id: 'chat-demo-anya', name: null, isGroup: false, isChannel: false,
    participants: [{ userId: anya.id, displayName: anya.displayName, avatarUrl: null }],
    avatarUrl: null, lastMessage: null, unreadCount: 2, muted: false,
  };
  const teamChat = {
    id: 'chat-demo-team', name: 'Команда Trandi', isGroup: true, isChannel: false,
    participants: [
      { userId: me.id, displayName: me.displayName, avatarUrl: null },
      { userId: anya.id, displayName: anya.displayName, avatarUrl: null },
      { userId: boris.id, displayName: boris.displayName, avatarUrl: null },
      { userId: masha.id, displayName: masha.displayName, avatarUrl: null },
    ],
    avatarUrl: null, lastMessage: null, unreadCount: 0, muted: false,
  };
  const newsChannel = {
    id: 'chat-demo-news', name: 'Новости Trandi', isGroup: false, isChannel: true,
    participants: [], avatarUrl: null, lastMessage: null, unreadCount: 1, muted: false,
  };

  const anyaMsgs = [
    mkMsg(anyaChat.id, anya, 'Привет! 👋 Добро пожаловать в демо-режим Trandi.', 62),
    mkMsg(anyaChat.id, anya, 'Здесь всё работает как в настоящем приложении — только данные не сохраняются.', 40),
    mkMsg(anyaChat.id, me, 'Спасибо! Пока осматриваюсь 🙂', 35),
    mkMsg(anyaChat.id, anya, 'Открой AI-ассистент слева — там можно сгенерировать картинку 🤖', 3),
  ];
  const teamMsgs = [
    mkMsg(teamChat.id, boris, 'Всем привет! Собрали демо-сборку 🚀', 180),
    mkMsg(teamChat.id, masha, 'Класс, уже смотрю', 175),
    mkMsg(teamChat.id, anya, 'Не забудьте про обучение при первом входе', 170),
  ];
  const selfMsgs = [
    mkMsg(selfChat.id, me, 'Личные заметки: это демо-данные, они исчезнут при выходе из демо-режима.', 55),
  ];
  const newsMsgs = [
    mkMsg(newsChannel.id, boris, 'Канал Trandi: следите за обновлениями! 📢', 300),
  ];
  anyaChat.lastMessage = anyaMsgs[anyaMsgs.length - 1];
  teamChat.lastMessage = teamMsgs[teamMsgs.length - 1];
  selfChat.lastMessage = selfMsgs[selfMsgs.length - 1];
  newsChannel.lastMessage = newsMsgs[newsMsgs.length - 1];

  return {
    chats: [selfChat, anyaChat, teamChat, newsChannel],
    messages: {
      [selfChat.id]: selfMsgs,
      [anyaChat.id]: anyaMsgs,
      [teamChat.id]: teamMsgs,
      [newsChannel.id]: newsMsgs,
    },
    scheduled: [],
    aiHistory: [],
    stories: [
      {
        userId: anya.id,
        userAvatarUrl: null,
        userDisplayName: 'Аня',
        stories: [
          {
            id: uid('story'),
            userId: anya.id,
            userAvatarUrl: null,
            userDisplayName: 'Аня',
            createdAt: new Date(Date.now() - 120 * 60000).toISOString(),
            bgColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            textContent: 'Привет из демо-режима ✨',
            textColor: '#ffffff',
            textSize: 34,
            textX: 50,
            textY: 50,
            textRotation: -4,
          },
        ],
      },
    ],
  };
}

export function resetDemoState() {
  seq = 100;
  demo = buildDemoState();
}

function ensureDemo() {
  if (!demo) demo = buildDemoState();
  return demo;
}

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

function ok(config, data, status = 200) {
  return { data, status, statusText: 'OK', headers: {}, config };
}

function fail(config, status, message) {
  const err = new Error(message);
  err.config = config;
  err.response = { status, data: { message }, headers: {}, config };
  return Promise.reject(err);
}

function parseBody(config) {
  const d = config.data;
  if (!d) return {};
  if (typeof d === 'string') {
    try {
      return JSON.parse(d);
    } catch (e) {
      return {};
    }
  }
  if (typeof FormData !== 'undefined' && d instanceof FormData) {
    const o = {};
    d.forEach((v, k) => {
      o[k] = v;
    });
    return o;
  }
  return d;
}

function fileUrl(file) {
  try {
    return URL.createObjectURL(file);
  } catch (e) {
    return null;
  }
}

function findDemoUser(id) {
  return DEMO_USERS.find((u) => u.id === id) || DEMO_USERS[1];
}

function addMessage(chatId, msg) {
  const s = ensureDemo();
  if (!s.messages[chatId]) s.messages[chatId] = [];
  s.messages[chatId].push(msg);
  const chat = s.chats.find((c) => c.id === chatId);
  if (chat) chat.lastMessage = msg;
  return msg;
}

// Точка входа всех запросов axios в демо-режиме (см. services/api.js).
export async function demoRequest(config) {
  const s = ensureDemo();
  const method = (config.method || 'get').toUpperCase();
  const full = `${config.baseURL || ''}${config.url || ''}`;
  const path = full.replace(/^\/api/, '').split('?')[0];
  const body = parseBody(config);
  await wait(60 + Math.random() * 120);

  // --- пользователи ---
  if (path === '/users/me') return ok(config, { ...DEMO_USER });
  if (path === '/users/search') return ok(config, []);
  if (/^\/users\/[^/]+$/.test(path)) {
    const id = path.split('/')[2];
    const u = findDemoUser(id);
    return ok(config, {
      id: u.id, username: u.username, displayName: u.displayName, email: u.email,
      avatarUrl: null, statusText: u.statusText, emailConfirmed: true,
      isAdmin: false, isBlocked: false,
    });
  }
  if (path === '/users/account' || path === '/users/password' || path === '/auth/change-email') {
    return fail(config, 400, 'В демо-режиме это действие недоступно');
  }
  if (method === 'PUT' && /^\/users\//.test(path)) return ok(config, { ok: true });
  if (method === 'POST' && /^\/users\//.test(path)) return ok(config, { ok: true });

  // --- чаты ---
  if (path === '/chats' && method === 'GET') return ok(config, s.chats.map((c) => ({ ...c })));
  if (path === '/chats/self') {
    const self = s.chats.find((c) => c.name === 'Своё');
    return ok(config, self ? { ...self } : null);
  }
  if (path === '/chats' && method === 'POST') {
    const ids = body.participantIds || [];
    const other = findDemoUser(ids[0]);
    const chat = {
      id: uid('chat'),
      name: body.isGroup ? body.name || 'Новая группа' : null,
      isGroup: !!body.isGroup,
      isChannel: false,
      participants: [
        { userId: DEMO_USER.id, displayName: DEMO_USER.displayName, avatarUrl: null },
        ...ids.map((id) => {
          const u = findDemoUser(id);
          return { userId: u.id, displayName: u.displayName, avatarUrl: null };
        }),
      ],
      avatarUrl: null,
      lastMessage: body.isGroup ? null : mkMsg(uid('chat'), other, 'Демо-чат создан 👋', 0),
      unreadCount: 0,
      muted: false,
    };
    if (!body.isGroup && chat.lastMessage) s.messages[chat.id] = [chat.lastMessage];
    s.chats = [chat, ...s.chats];
    return ok(config, { ...chat });
  }
  const chatIdMatch = path.match(/^\/chats\/([^/]+)(\/.*)?$/);
  if (chatIdMatch) {
    const chatId = chatIdMatch[1];
    const rest = chatIdMatch[2] || '';
    const chat = s.chats.find((c) => c.id === chatId);

    if (rest === '/messages' && method === 'GET') {
      return ok(config, (s.messages[chatId] || []).map((m) => ({ ...m })));
    }
    if (rest === '/messages' && method === 'POST') {
      if (body.scheduledAt) {
        const scheduled = {
          id: uid('sched'), chatId, content: body.content, type: 'TEXT',
          scheduledAt: body.scheduledAt, createdAt: new Date().toISOString(),
        };
        s.scheduled.push(scheduled);
        return ok(config, scheduled);
      }
      const msg = mkMsg(chatId, DEMO_USER, body.content || '', 0);
      addMessage(chatId, msg);
      return ok(config, { ...msg });
    }
    if (rest === '/messages/file' && method === 'POST') {
      const f = body.file;
      const msg = {
        ...mkMsg(chatId, DEMO_USER, body.type === 'IMAGE' ? '📷 Фото' : '📎 Файл', 0),
        type: body.type || 'FILE',
        attachments: [{
          fileName: (f && f.name) || 'demo-file',
          fileUrl: f ? fileUrl(f) : null,
          url: f ? fileUrl(f) : null,
          mimeType: f ? f.type : null,
        }],
      };
      addMessage(chatId, msg);
      return ok(config, { ...msg });
    }
    const fwd = path.match(/^\/chats\/([^/]+)\/messages\/forward$/);
    if (fwd && method === 'POST') {
      const source = s.messages[body.sourceChatId] || [];
      const orig = source.find((m) => m.id === body.messageId);
      const msg = mkMsg(chatId, DEMO_USER, orig ? `↪ ${orig.content}` : '↪ Пересланное', 0);
      addMessage(chatId, msg);
      return ok(config, { ...msg });
    }
    if (rest === '/messages/pinned' && method === 'GET') {
      return ok(config, (s.messages[chatId] || []).filter((m) => m.isPinned));
    }
    const react = path.match(/^\/chats\/([^/]+)\/messages\/([^/]+)\/reactions(?:\/([^/]+))?$/);
    if (react) {
      const list = s.messages[chatId] || [];
      const m = list.find((x) => x.id === react[2]);
      if (!m) return ok(config, []);
      if (method === 'POST') {
        m.reactions = [...(m.reactions || []), { emoji: body.emoji, userId: DEMO_USER.id }];
      } else {
        const emoji = react[3] ? decodeURIComponent(react[3]) : null;
        m.reactions = (m.reactions || []).filter((r) => !(r.userId === DEMO_USER.id && r.emoji === emoji));
      }
      return ok(config, m.reactions.map((r) => ({ ...r })));
    }
    const msgCrud = path.match(/^\/chats\/([^/]+)\/messages\/([^/]+)$/);
    if (msgCrud && method === 'PUT') {
      const m = (s.messages[chatId] || []).find((x) => x.id === msgCrud[2]);
      if (m) {
        m.content = body.content;
        m.editedAt = new Date().toISOString();
      }
      return ok(config, m ? { ...m } : null);
    }
    if (msgCrud && method === 'DELETE') {
      const m = (s.messages[chatId] || []).find((x) => x.id === msgCrud[2]);
      if (m) {
        m.isDeleted = true;
        m.content = '';
        m.attachments = [];
      }
      return ok(config, { ok: true });
    }
    const pin = path.match(/^\/chats\/([^/]+)\/messages\/([^/]+)\/(pin|unpin)$/);
    if (pin && method === 'POST') {
      const m = (s.messages[chatId] || []).find((x) => x.id === pin[2]);
      if (m) m.isPinned = pin[3] === 'pin';
      return ok(config, m ? { ...m } : null);
    }
    if (rest === '/read') {
      if (chat) chat.unreadCount = 0;
      return ok(config, { ok: true });
    }
    if (rest === '/mute') {
      if (chat) chat.muted = !!body.muted;
      return ok(config, { ok: true });
    }
    if (rest === '/rename') {
      if (chat) chat.name = body.name;
      return ok(config, { ok: true });
    }
    if (method === 'DELETE') {
      s.chats = s.chats.filter((c) => c.id !== chatId);
      delete s.messages[chatId];
      return ok(config, { ok: true });
    }
    if (rest === '/shared-files') return ok(config, []);
    if (rest === '/avatar' || rest === '/avatars') return ok(config, { ok: true });
    if (chat) return ok(config, { ...chat });
    return ok(config, null);
  }

  // --- каналы ---
  if (path === '/channels' && method === 'GET') {
    return ok(config, s.chats.filter((c) => c.isChannel).map((c) => ({ ...c })));
  }
  if (path === '/channels' && method === 'POST') {
    const chat = {
      id: uid('channel'), name: body.name || 'Новый канал', isGroup: false, isChannel: true,
      participants: [], avatarUrl: null, lastMessage: null, unreadCount: 0, muted: false,
    };
    s.chats = [chat, ...s.chats];
    return ok(config, { ...chat });
  }
  const sub = path.match(/^\/channels\/([^/]+)\/subscribe$/);
  if (sub) {
    const chat = s.chats.find((c) => c.id === sub[1]);
    return ok(config, chat ? { ...chat } : null);
  }
  if (/^\/channels\/[^/]+\/rss-feeds/.test(path)) {
    if (method === 'GET') return ok(config, []);
    return ok(config, { ok: true });
  }

  // --- сообщения-запросы в чат ---
  if (path === '/chat-requests/incoming') return ok(config, []);
  if (path === '/chat-requests/start' && method === 'POST') {
    const other = findDemoUser(body.targetUserId);
    const chat = {
      id: uid('chat'), name: null, isGroup: false, isChannel: false,
      participants: [
        { userId: DEMO_USER.id, displayName: DEMO_USER.displayName, avatarUrl: null },
        { userId: other.id, displayName: other.displayName, avatarUrl: null },
      ],
      avatarUrl: null, lastMessage: null, unreadCount: 0, muted: false,
    };
    s.chats = [chat, ...s.chats];
    return ok(config, { type: 'chat_created', chat: { ...chat } });
  }

  // --- запланированные ---
  if (path === '/scheduled-messages' && method === 'GET') return ok(config, s.scheduled.map((x) => ({ ...x })));
  if (/^\/scheduled-messages\/[^/]+$/.test(path) && method === 'DELETE') {
    const id = path.split('/')[2];
    s.scheduled = s.scheduled.filter((x) => x.id !== id);
    return ok(config, { ok: true });
  }

  // --- сторис ---
  if (path === '/stories' && method === 'GET') {
    return ok(config, s.stories.map((g) => ({
      ...g,
      stories: g.stories.map((st) => ({ ...st })),
    })));
  }
  if (path === '/stories' && method === 'POST') {
    const f = body.file;
    const myGroup = s.stories.find((g) => g.userId === DEMO_USER.id);
    const story = {
      id: uid('story'),
      userId: DEMO_USER.id,
      userAvatarUrl: null,
      userDisplayName: DEMO_USER.displayName,
      createdAt: new Date().toISOString(),
      imageUrl: f ? fileUrl(f) : null,
      textContent: body.textContent || '',
      textColor: body.textColor || '#ffffff',
      textSize: Number(body.textSize) || 28,
      textX: Number(body.textX) || 50,
      textY: Number(body.textY) || 50,
      textRotation: Number(body.textRotation) || 0,
    };
    if (myGroup) myGroup.stories.push(story);
    else s.stories.unshift({
      userId: DEMO_USER.id, userAvatarUrl: null, userDisplayName: DEMO_USER.displayName, stories: [story],
    });
    return ok(config, { ok: true });
  }
  if (/^\/stories\/[^/]+$/.test(path) && method === 'DELETE') {
    const id = path.split('/')[2];
    s.stories.forEach((g) => {
      g.stories = g.stories.filter((st) => st.id !== id);
    });
    s.stories = s.stories.filter((g) => g.stories.length > 0);
    return ok(config, { ok: true });
  }

  // --- AI ---
  if (path === '/ai/models') return ok(config, [{ id: 'demo-model', name: 'MashaGPT (демо)' }]);
  if (path === '/ai/limit') return ok(config, { remaining: 5, monthlyLimit: 5, limited: false, unlimited: true });
  if (path === '/ai/subscribe') return fail(config, 400, 'В демо-режиме подписка недоступна');
  if (path === '/ai/history' && method === 'GET') return ok(config, s.aiHistory.map((m) => ({ ...m })));
  if (path === '/ai/history' && method === 'POST') {
    const item = {
      id: uid('ai'), role: body.role || 'user', content: body.content || '',
      createdAt: new Date().toISOString(),
    };
    s.aiHistory.push(item);
    return ok(config, item);
  }
  if (path === '/ai/generate-image' && method === 'POST') {
    const jobId = uid('job');
    const prompt = body.prompt || '';
    // Имитация фоновой генерации: через 2 с событие как от WebSocket.
    setTimeout(() => {
      if (!isDemoMode()) return;
      const assistantMsg = {
        id: uid('ai'), role: 'assistant', content: prompt,
        imageUrl: DEMO_AI_IMAGE, createdAt: new Date().toISOString(),
      };
      ensureDemo().aiHistory.push(assistantMsg);
      try {
        window.dispatchEvent(new CustomEvent('ai_generation_done', {
          detail: { jobId, imageUrl: DEMO_AI_IMAGE, prompt },
        }));
      } catch (e) {}
    }, 2000);
    return ok(config, { jobId });
  }

  // --- инвайты, файлы, стикеры ---
  if (path === '/invites' && method === 'POST') {
    return ok(config, { url: `${window.location.origin}/register?invite=demo`, inviterName: DEMO_USER.displayName });
  }
  if (/^\/invites\/[^/]+$/.test(path)) return ok(config, { inviterName: DEMO_USER.displayName });
  if (path === '/files/upload' && method === 'POST') {
    const f = body.file;
    return ok(config, { url: f ? fileUrl(f) : null, fileName: (f && f.name) || 'demo' });
  }
  if (/^\/stickers\//.test(path)) return ok(config, []);

  // --- админка в демо недоступна ---
  if (/^\/admin\//.test(path)) return fail(config, 400, 'Админка недоступна в демо-режиме');

  // --- прочее ---
  if (method === 'GET') return ok(config, []);
  return ok(config, { ok: true });
}
